// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"eee0787b","766":"6fb2e23e","946":"54fefbf8"}[chunkId] + ".chunk.js";
};